import type { Account } from "@veto/domain";
import { ModalShell } from "../components/ModalShell";
import { ProfileTab } from "./ProfileTab";
import type { ProfileInput } from "../hooks/useProfileActions";

/**
 * Dedicated profile screen — separate from Settings (SPEC §5.5).
 * Opened from the top-bar avatar; Settings no longer embeds the editor.
 */
export function ProfileModal({
  account,
  onClose,
  onSaveProfile,
  onToast,
}: {
  account: Account;
  onClose: () => void;
  onSaveProfile: (input: ProfileInput) => Promise<void>;
  onToast: (msg: string) => void;
}) {
  return (
    <ModalShell
      title="Profile"
      ariaLabel="Profile"
      onClose={onClose}
      size="sm"
      className="profile-modal"
    >
      <ProfileTab
        account={account}
        onSaveProfile={onSaveProfile}
        onToast={onToast}
        onClose={onClose}
      />
    </ModalShell>
  );
}
